import { render } from "./OptionsBox.vue?vue&type=template&id=c4126824&scoped=true"
import script from "./OptionsBox.vue?vue&type=script&lang=js"
export * from "./OptionsBox.vue?vue&type=script&lang=js"

import "./OptionsBox.vue?vue&type=style&index=0&id=c4126824&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4126824"]])

export default __exports__